import { api } from './api';

interface CreateInvitationRequest {
  teamId: string;
  invitedFirstName: string;
  invitedLastName: string;
  invitedEmail: string;
}

interface InvitationResponse {
  id: string;
  teamId: string;
  invitedEmail: string;
  invitedFirstName: string;
  invitedLastName: string;
  invitedBy: string;
  token: string;
  expiresAt: string;
  status: 'PENDING' | 'ACCEPTED' | 'EXPIRED';
  createdAt: string;
}

interface AcceptInvitationRequest {
  password: string;
}

interface AcceptInvitationResponse {
  user: {
    id: string;
    email: string;
    role: string;
    profile: {
      firstName: string;
      lastName: string;
    };
  };
  token: string;
}

interface InvitationDetailsResponse {
  teamName: string;
  invitedBy: {
    firstName: string;
    lastName: string;
  };
  invitedEmail: string;
  invitedFirstName: string;
  invitedLastName: string;
  expiresAt: string;
  status: 'PENDING' | 'ACCEPTED' | 'EXPIRED';
}

export const invitationService = {
  async createInvitation(data: CreateInvitationRequest): Promise<InvitationResponse> {
    const response = await api.post<{ data: InvitationResponse }>('/auth/invitations', data);
    return response.data.data;
  },

  async getInvitationDetails(token: string): Promise<InvitationDetailsResponse> {
    const response = await api.get<{ data: InvitationDetailsResponse }>(`/auth/invitations/${token}`);
    return response.data.data;
  },

  async acceptInvitation(token: string, data: AcceptInvitationRequest): Promise<AcceptInvitationResponse> {
    const response = await api.post<{ data: AcceptInvitationResponse }>(
      `/auth/invitations/${token}/accept`,
      data
    );
    return response.data.data;
  },
};
